const translations = {
  // Nav
  "nav.home": "کور",
  "nav.mission": "ماموریت",
  "nav.projects": "پروژې",
  "nav.stories": "کیسې",
  "nav.volunteer": "رضاکار",
  "nav.donate": "مرسته",
  "nav.contact": "اړیکه",
  "nav.donateNow": "اوس مرسته وکړئ",

  // Language bar
  "lang.managed": "د اډمین CMS ډشبورډ له لارې اداره کیږي",

  // Hero
  "hero.badge": "پلونه جوړول · هیله رامنځته کول",
  "hero.title": "د زده کړې او فرصتونو له لارې د افغان ټولنو پیاوړتیا",
  "hero.subtitle": "د کاناډا افغانستان بنسټ مهربان کاناډایان له اړمنو افغان ټولنو سره نښلوي — له ۲۰۱۶ کال راهیسې د زده کړې، روغتیا او دوامداره پرمختګ تمویل کوي.",
  "hero.cta.donate": "زموږ ماموریت ملاتړ وکړئ",
  "hero.cta.learn": "زموږ کیسه زده کړئ",
  "hero.scroll": "ښکته",

  // Mission Preview
  "mission.tag": "زموږ ماموریت",
  "mission.title": "د دوو هیوادونو ترمنځ یو پل، چې په مهربانۍ جوړ شوی",
  "mission.body1": "د کاناډا افغانستان بنسټ (CAF) یو ثبت شوی کاناډایی خیریه بنسټ دی چې د زده کړې، روغتیا او ټولنیز پرمختګ کې د هدفمندو پروګرامونو له لارې د افغانانو د ژوند ښه کولو ته وقف شوی دی.",
  "mission.body2": "موږ باور لرو چې هر افغان ماشوم د زده کړې حق لري، هره کورنۍ پاکو اوبو ته مستحقه ده، او هره ټولنه د ودې چانس مستحق ده — پرته له دې چې جګړه وي که شرایط.",
  "mission.cta": "زموږ بشپړ ماموریت ولولئ",
  "mission.pillar.education": "زده کړه",
  "mission.pillar.education.desc": "د افغان ځوانانو او ښځو لپاره د ښوونځیو، سکالرشیپونو او مسلکي زده کړو تمویل.",
  "mission.pillar.healthcare": "روغتیا",
  "mission.pillar.healthcare.desc": "په لرې پرتو سیمو کې د ګرځنده روغتیايي مرکزونو ځای پرځای کول او د طبي متخصصینو ملاتړ.",
  "mission.pillar.community": "ټولنه",
  "mission.pillar.community.desc": "د زیربناوو جوړول، پاکو اوبو ته لاسرسی او په کاناډا کې د کډوالو بیا میشتیدو ملاتړ.",
  "mission.pillar.sustainability": "دوامدارتیا",
  "mission.pillar.sustainability.desc": "د تلپاتې او ځان بسیا بدلون لپاره د سیمه‌ییزو مشرانو او سازمانونو پیاوړتیا.",

  // Projects Preview
  "projects.tag": "فعالې پروژې",
  "projects.title": "زموږ اوسنۍ پروژې",
  "projects.subtitle": "هره پروژه په دقت سره طرحه شوې ترڅو په افغان ټولنو کې تلپاتې اغیزه رامنځته کړي. دلته هغه څه دي چې موږ اوس پرې کار کوو.",
  "projects.viewAll": "ټولې پروژې وګورئ",
  "projects.learnMore": "نور زده کړئ",
  "projects.raised": "راټول شوي",
  "projects.completed": "بشپړې شوې",

  // Impact
  "impact.tag": "زموږ اغیزه",
  "impact.title": "ریښتینی بدلون، ریښتیني شمیرې",
  "impact.subtitle": "هر مرسته شوی ډالر په ساحه کې د اندازه کیدونکي اغیزې لامل کیږي. دلته هغه څه دي چې موږ په ګډه ترلاسه کړي دي.",
  "impact.students": "ملاتړ شوي زده کوونکي",
  "impact.students.desc": "هغه نجونې او هلکان چې زموږ د سکالرشیپ او ښوونځي پروګرامونو له لارې کیفیت لرونکې زده کړې ترلاسه کوي.",
  "impact.water": "پاکو اوبو ته لاسرسی لرونکي خلک",
  "impact.water.desc": "په کلیوالي افغانستان کې کورنۍ اوس خوندي او پاکو څښاک اوبو ته لاسرسی لري.",
  "impact.medical": "طبي معاینات",
  "impact.medical.desc": "له ۲۰۱۸ کال راهیسې زموږ د ګرځنده روغتیايي مرکزونو پروګرام له لارې وړیا روغتیايي خدمتونه.",
  "impact.families": "بیا میشتې شوې کورنۍ",
  "impact.families.desc": "افغان کډوالې کورنۍ چې په کاناډا کې په خپل نوي ژوند کې ملاتړ شوې دي.",

  // Volunteer Preview
  "volunteer.tag": "برخه واخلئ",
  "volunteer.title": "زموږ د بدلون راوستونکو ټولنې سره یوځای شئ",
  "volunteer.body1": "که تاسو ډاکټر یاست، ژباړن یاست، تمویل راټولونکی یاست، یا د ټولنیزو رسنیو مینه وال یاست — ستاسو لپاره په CAF کې ځای شته. ستاسو مهارتونه کولی شي ژوند بدل کړي.",
  "volunteer.body2": "موږ د کاناډایانو او افغان مهاجرو لپاره د رضاکارۍ فرصتونه لرو، لرې پرتې او حضوري دواړه.",
  "volunteer.cta": "رضاکار شئ",
  "volunteer.otherWays": "یا د مرستې نورې لارې وپلټئ",
  "volunteer.apply": "غوښتنه",
  "volunteer.location": "ځای",

  // Donate Preview
  "donate.tag": "توپیر رامنځته کړئ",
  "donate.title": "ستاسو مرسته، د هغوی راتلونکی",
  "donate.subtitle": "ستاسو د مرستې ۱۰۰٪ په مستقیم ډول په ساحه کې پروګرامونو ته ځي. موږ یو ثبت شوی کاناډایی خیریه بنسټ یو — ټولې مرستې د مالیې معافیت وړ دي.",
  "donate.tier.supporter": "ملاتړی",
  "donate.tier.champion": "اتل",
  "donate.tier.patron": "ساتونکی",
  "donate.mostPopular": "ډېر مشهور",
  "donate.highImpact": "لوړه اغیزه",
  "donate.donate": "مرسته",
  "donate.trust.charity": "ثبت شوی کاناډایی خیریه بنسټ",
  "donate.trust.transparent": "۱۰۰٪ شفاف",
  "donate.trust.receipts": "مالیاتي رسیدونه صادریږي",
  "donate.trust.secure": "خوندي پروسه",

  // Footer
  "footer.tagline": "د زده کړې، روغتیا او ټولنیز پرمختګ له لارې د کاناډا او افغانستان ترمنځ پلونه جوړول.",
  "footer.charity": "د CRA ثبت شوی خیریه #123456789",
  "footer.est": "په ۲۰۱۶ تاسیس شوی",
  "footer.quickLinks": "چټک لینکونه",
  "footer.getInvolved": "برخه واخلئ",
  "footer.stayConnected": "په اړیکه کې اوسئ",
  "footer.newsletter.desc": "زموږ د اغیزې او د مرستې د لارو په اړه میاشتني تازه معلومات ترلاسه کړئ.",
  "footer.newsletter.placeholder": "ستاسو بریښنالیک پته",
  "footer.newsletter.success": "د ګډون لپاره مننه!",
  "footer.newsletter.privacy": "موږ ستاسو محرمیت ته درناوی لرو. هر وخت ګډون لغوه کړئ.",
  "footer.support": "په دې ژبو کې ملاتړ شتون لري:",
  "footer.privacy": "د محرمیت تګلاره",
  "footer.terms": "د کارولو شرایط",
  "footer.accessibility": "لاسرسی",
  "footer.admin": "اډمین",
  "footer.copyright": "د کاناډا افغانستان بنسټ. ټول حقوق خوندي دي.",

  // Contact
  "contact.tag": "اړیکه ونیسئ",
  "contact.title": "موږ خوښ یو چې تاسو څخه واورو",
  "contact.subtitle": "زموږ د پروګرامونو په اړه پوښتنې لرئ، زموږ سره ملګرتیا غواړئ، یا ملاتړ ته اړتیا لرئ؟ اړیکه ونیسئ — موږ په انګلیسي، پښتو، دري، فرانسوي او الماني ژبو ځواب ورکوو.",
  "contact.form.name": "بشپړ نوم",
  "contact.form.email": "بریښنالیک پته",
  "contact.form.subject": "موضوع",
  "contact.form.message": "ستاسو پیغام",
  "contact.form.submit": "پیغام واستوئ",
  "contact.form.sending": "لیږل کیږي...",
  "contact.form.success": "پیغام واستول شو! موږ به په ۴۸ ساعتونو کې تاسو ته ځواب ووایو.",
  "contact.info.address": "پته",
  "contact.info.email": "بریښنالیک",
  "contact.info.phone": "تلیفون",
  "contact.info.hours": "د دفتر ساعتونه",

  // ========== MISSION PAGE ==========
  "missionPage.tag": "زموږ ماموریت",
  "missionPage.title": "یو ماموریت چې په هیله ريښه لري، د عمل له لارې پرمخ وړل کیږي",
  "missionPage.subtitle": "د کاناډا افغانستان بنسټ شتون لري ترڅو د مهربانو کاناډایانو او اړمنو افغان ټولنو ترمنځ واټن ډک کړي — د زده کړې، روغتیا او ټولنیز پرمختګ له لارې دوامداره بدلون رامنځته کول.",
  "missionPage.who.tag": "موږ څوک یو",
  "missionPage.who.title": "د دوو هیوادونو ترمنځ پلونه جوړول",
  "missionPage.who.body1": "په ۲۰۱۶ کال کې د افغان-کاناډایی ټولنې د مشرانو لخوا تاسیس شوی، CAF یو ثبت شوی کاناډایی خیریه بنسټ دی (CRA #123456789) چې د هدفمندو، شفافو او اغیزمنو پروګرامونو له لارې د افغانانو د ژوند ښه کولو ته وقف شوی دی.",
  "missionPage.who.body2": "موږ باور لرو چې جغرافیه او جګړه باید هیڅکله د ماشوم زده کړې ته لاسرسی، د کورنۍ پاکو اوبو ته لاسرسی، یا د ټولنې د ودې وړتیا ونه ټاکي. زموږ کار د دې اصل پر بنسټ دی چې دوامداره بدلون له ټولنو دننه راځي — موږ پیاوړي کوو، نه ځای نیسو.",
  "missionPage.who.body3": "په کاناډا او افغانستان کې د ۳۴۰+ وقف شویو کسانو رضاکاره شبکې او د سیمه‌ییزو افغان نادولتي سازمانونو سره ملګرتیا سره، موږ ډاډ ترلاسه کوو چې هر ډالر هغو کسانو ته رسیږي چې ورته ډېره اړتیا لري.",
  "missionPage.who.ctaProjects": "زموږ پروژې وګورئ",
  "missionPage.who.ctaSupport": "زموږ ملاتړ وکړئ",
  "missionPage.who.yearsBadge": "کلونه اغیزه",
  "missionPage.values.tag": "څه شی موږ لارښوونه کوي",
  "missionPage.values.title": "زموږ اساسي ارزښتونه",
  "missionPage.values.compassion": "مهرباني",
  "missionPage.values.compassionDesc": "موږ له هر هغه چا سره چې خدمت یې کوو، له زړه سوي او پاملرنې سره چلند کوو، پرته له دې چې شالید یا شرایط یې څه وي.",
  "missionPage.values.integrity": "صداقت",
  "missionPage.values.integrityDesc": "موږ خپلو مرسته کوونکو او هغو ټولنو ته چې خدمت یې کوو، په بشپړ مالي شفافیت او حساب ورکونې سره کار کوو.",
  "missionPage.values.collaboration": "همکاري",
  "missionPage.values.collaborationDesc": "موږ د اغیزې اعظمي کولو لپاره له سیمه‌ییزو افغان سازمانونو، کاناډایی ادارو او نړیوالو نادولتي موسسو سره ملګرتیا کوو.",
  "missionPage.values.sustainability": "دوامدارتیا",
  "missionPage.values.sustainabilityDesc": "موږ داسې پروګرامونه طرحه کوو چې ټولنې د وخت په تیریدو سره ځان بسیا او مقاومې شي.",
  "missionPage.values.equity": "برابري",
  "missionPage.values.equityDesc": "موږ په خپلو ټولو پروګرامونو کې تر ټولو زیان منونکو — ښځو، ماشومانو او بې ځایه شویو کورنیو — ته لومړیتوب ورکوو.",
  "missionPage.values.innovation": "نوښت",
  "missionPage.values.innovationDesc": "موږ په دوامداره توګه د پېچلو بشري ننګونو لپاره تخلیقي او شواهد-بنسټ حل لارې لټوو.",
  "missionPage.timeline.tag": "زموږ سفر",
  "missionPage.timeline.title": "د اغیزې ۸ کاله",
  "missionPage.timeline.2016": "CAF په اوټاوا کې د افغان-کاناډایی ټولنې د مشرانو لخوا تاسیس شو",
  "missionPage.timeline.2017": "په کابل کې د نجونو د زده کړې لومړنی سکالرشیپ پروګرام پیل شو",
  "missionPage.timeline.2018": "په ننګرهار ولایت کې د ګرځنده روغتیايي مرکزونو پروګرام پیل شو",
  "missionPage.timeline.2019": "په هلمند کې د پاکو اوبو نوښت ۵۰۰۰ کورنیو ته ورسید",
  "missionPage.timeline.2020": "د کوویډ-۱۹ بیړنۍ مرستې — ۳۰۰۰ کورنیو ته محافظتي وسایل او خواړه وویشل شول",
  "missionPage.timeline.2021": "په ټورنټو او اوټاوا کې د کډوالو د بیا میشتیدنې پروګرام پیل شو",
  "missionPage.timeline.2022": "په هرات او مزار شریف کې د مسلکي زده کړو مرکزونه پرانستل شول",
  "missionPage.timeline.2023": "د افغانستان په ۸ ولایتونو کې ۱۵ فعالو پروژو ته پراختیا ومونده",
  "missionPage.timeline.2024": "له ۲۵۰۰ څخه ډېر زده کوونکي ملاتړ شول؛ ۱۸۰۰۰+ خلک پاکو اوبو ته لاسرسی لري",
  "missionPage.cta.title": "د ماموریت برخه اوسئ",
  "missionPage.cta.subtitle": "که تاسو مرسته کوئ، رضاکار یاست، یا یوازې خبر خپروئ — تاسو د بدلون برخه یاست.",
  "missionPage.cta.donate": "اوس مرسته وکړئ",
  "missionPage.cta.volunteer": "زموږ سره رضاکار شئ",

  // ========== PROJECTS PAGE ==========
  "projectsPage.tag": "څه کوو موږ",
  "projectsPage.title": "زموږ پروژې",
  "projectsPage.subtitle": "له کابل کې له ټولګیو څخه په هلمند کې د اوبو څاه ګانو ته — هره پروژه د یو ښه افغانستان په لور یو ګام دی.",
  "projectsPage.filters.all": "ټول",
  "projectsPage.filters.education": "زده کړه",
  "projectsPage.filters.healthcare": "روغتیا",
  "projectsPage.filters.infrastructure": "زیربنا",
  "projectsPage.filters.community": "ټولنه",
  "projectsPage.filters.humanitarian": "بشري مرستې",
  "projectsPage.status.all": "ټول",
  "projectsPage.status.active": "فعال",
  "projectsPage.status.completed": "بشپړ",
  "projectsPage.empty": "د دې فلټر لپاره هیڅ پروژه ونه موندل شوه.",
  "projectsPage.details": "جزیات",
  "projectsPage.raised": "راټول شوي",
  "projectsPage.badge.completed": "بشپړه شوې",

  // ========== PROJECT DETAIL PAGE ==========
  "projectDetail.home": "کور",
  "projectDetail.projects": "پروژې",
  "projectDetail.notFound": "پروژه ونه موندل شوه",
  "projectDetail.notFound.back": "پروژو ته وګرځئ",
  "projectDetail.funding.title": "د تمویل پرمختګ",
  "projectDetail.funding.raised": "له",
  "projectDetail.funding.goal": "هدف څخه راټول شوي",
  "projectDetail.funding.funded": "تامین شوی",
  "projectDetail.funding.cta": "دې پروژې ته مرسته وکړئ",
  "projectDetail.details.title": "د پروژې جزیات",
  "projectDetail.details.category": "کټګوري",
  "projectDetail.details.location": "ځای",
  "projectDetail.details.beneficiaries": "ګټه اخیستونکي",
  "projectDetail.details.status": "حالت",
  "projectDetail.details.statusActive": "فعال",
  "projectDetail.details.statusCompleted": "بشپړه شوې",
  "projectDetail.body1": "دا نوښت په افغانستان کې د دوامداره او ټولنې-محوره پرمختګ رامنځته کولو لپاره د CAF د پراخې ژمنې برخه ده. په ساحه کې زموږ سیمه‌ییز همکاران ډاډ ورکوي چې سرچینې په عادلانه توګه وویشل شي او پروګرامونه له کلتوري پلوه مناسب او اغیزمن وي.",
  "projectDetail.body2": "ټولې راټولې شوې پیسې په مستقیم ډول د پروګرامونو پلي کولو ته ځي. CAF بشپړ مالي شفافیت ساتي او مرسته کوونکو ته د اغیزو منظم راپورونه وړاندې کوي. د ۲۰ کاناډایي ډالرو څخه پورته ټولو مرستو لپاره مالیاتي رسیدونه صادریږي.",
  "projectDetail.back": "ټولو پروژو ته وګرځئ",
  "projectDetail.beneficiariesSuffix": "ګټه اخیستونکي",

  // ========== VOLUNTEER PAGE ==========
  "volunteerPage.tag": "برخه واخلئ",
  "volunteerPage.title": "زموږ د بدلون راوستونکو ټولنې سره یوځای شئ",
  "volunteerPage.subtitle": "ستاسو مهارتونه، وخت او لیوالتیا کولی شي ژوند بدل کړي. که تاسو په کاناډا کې یاست یا بهر، ستاسو لپاره په CAF کې یو معنی لرونکی رول شته.",
  "volunteerPage.positions.tag": "خلاصې دندې",
  "volunteerPage.positions.title": "اوسني رضاکارۍ فرصتونه",
  "volunteerPage.stories.tag": "د رضاکارانو کیسې",
  "volunteerPage.stories.title": "زموږ له رضاکارانو څخه واورئ",
  "volunteerPage.apply.title": "د رضاکارۍ لپاره غوښتنه",
  "volunteerPage.apply.submitted": "غوښتنه ثبت شوه!",
  "volunteerPage.apply.submittedDesc": "ستاسو د علاقې لپاره مننه. زموږ ټیم به په ۳-۵ کاري ورځو کې تاسو سره اړیکه ونیسي.",
  "volunteerPage.apply.close": "تړل",
  "volunteerPage.form.name": "بشپړ نوم *",
  "volunteerPage.form.namePlaceholder": "ستاسو بشپړ نوم",
  "volunteerPage.form.email": "بریښنالیک پته *",
  "volunteerPage.form.emailPlaceholder": "ستاسو بریښنالیک",
  "volunteerPage.form.message": "تاسو ولې رضاکاري کول غواړئ؟ *",
  "volunteerPage.form.messagePlaceholder": "د خپل شالید او انګیزې په اړه ووایاست...",
  "volunteerPage.form.submit": "غوښتنه وسپارئ",
  "volunteerPage.form.submitting": "سپارل کیږي...",
  "volunteerPage.spotsAvailable": "ځایونه شتون لري",
  "volunteerPage.applyNow": "اوس غوښتنه وکړئ",

  // ========== DONATE PAGE ==========
  "donatePage.tag": "توپیر رامنځته کړئ",
  "donatePage.title": "CAF ته مرسته",
  "donatePage.subtitle": "ستاسو سخاوت په مستقیم ډول د افغان کورنیو لپاره د زده کړې، روغتیا او ټولنیزو پروګرامونو تمویل کوي. هر ډالر حساب لري.",
  "donatePage.yourImpact": "ستاسو اغیزه",
  "donatePage.howToDonate": "د مرستې څرنګوالی",
  "donatePage.tier.friend.label": "ملګری",
  "donatePage.tier.friend.impact": "د ۲ زده کوونکو لپاره ښوونځي توکي برابروي",
  "donatePage.tier.supporter.label": "ملاتړی",
  "donatePage.tier.supporter.impact": "د یو سمستر لپاره د ۵ زده کوونکو لپاره ښوونځي توکي برابروي",
  "donatePage.tier.advocate.label": "پلوی",
  "donatePage.tier.advocate.impact": "د یوې کورنۍ لپاره د ۲ میاشتو پاکو اوبو لګښت تمویلوي",
  "donatePage.tier.champion.label": "اتل",
  "donatePage.tier.champion.impact": "د ۶ کسیزې کورنۍ لپاره د یوې میاشتې پاکو اوبو لګښت تمویلوي",
  "donatePage.tier.benefactor.label": "خیر غوښتونکی",
  "donatePage.tier.benefactor.impact": "زموږ په ګرځنده روغتیايي مرکز کې د ۱۰ ناروغانو طبي پاملرنه پوښي",
  "donatePage.tier.patron.label": "ساتونکی",
  "donatePage.tier.patron.impact": "د یوې نجلۍ د ثانوي ښوونځي د بشپړ کال زده کړه تمویلوي",
  "donatePage.custom.label": "خپل خوښه اندازه (CAD)",
  "donatePage.custom.placeholder": "اندازه ولیکئ",
  "donatePage.custom.note": "د خپل خوښې مرستې لپاره، مهرباني وکړئ د پیسو ورکړې تنظیمولو لپاره له موږ سره مستقیم اړیکه ونیسئ.",
  "donatePage.custom.contact": "اړیکه ونیسئ",
  "donatePage.bank.title": "بانکي انتقال",
  "donatePage.bank.desc": "زموږ د کاناډا بانکي حساب ته مستقیم انتقال کړئ:",
  "donatePage.bank.name": "د کاناډا افغانستان بنسټ",
  "donatePage.bank.bank": "بانک",
  "donatePage.bank.bankName": "د کاناډا شاهي بانک (RBC)",
  "donatePage.bank.accountName": "د حساب نوم",
  "donatePage.bank.accountNum": "د حساب شمېره",
  "donatePage.bank.transit": "د ټرانزیټ شمېره",
  "donatePage.bank.institution": "د ادارې شمېره",
  "donatePage.bank.warning": "مهم: مهرباني وکړئ د انتقال په یادښتونو کې خپل بشپړ نوم او بریښنالیک ولیکئ ترڅو موږ ستاسو مالیاتي رسید صادر کړو.",
  "donatePage.cheque.title": "چک",
  "donatePage.cheque.desc": "یو چک چې دې نوم ته د ورکړې وړ وي پوسته کړئ:",
  "donatePage.cheque.warning": "مهرباني وکړئ د خپل مالیاتي رسید ترلاسه کولو لپاره د چک شا ته خپل بریښنالیک پته ولیکئ.",
  "donatePage.inperson.title": "حضوري",
  "donatePage.inperson.desc": "د کار په ساعتونو کې زموږ دفتر ته ورشئ:",
  "donatePage.inperson.note": "موږ په حضوري توګه نغدې پیسې، چک او ډیبټ/کریدت کارت منو.",
  "donatePage.tax.title": "مالیاتي رسیدونه",
  "donatePage.tax.desc": "CAF یو ثبت شوی کاناډایی خیریه بنسټ دی (CRA #123456789). د ۲۰ کاناډایي ډالرو څخه پورته ټولې مرستې د مالیاتي رسید وړ دي، چې ستاسو له مرستې څخه په ۳۰ ورځو کې صادریږي.",
  "donatePage.trust.charity": "ثبت شوی خیریه",
  "donatePage.trust.transparent": "۱۰۰٪ شفاف",
  "donatePage.trust.secure": "خوندي او مصؤن",
  "donatePage.trust.programs": "۱۰۰٪ پروګرامونو ته",
  "donatePage.bottom.title": "د مرستې په اړه پوښتنې لرئ؟",
  "donatePage.bottom.subtitle": "زموږ ټیم خوښ دی چې تاسو سره د تر ټولو اغیزمنې ممکنې مرستې په کولو کې مرسته وکړي.",
  "donatePage.bottom.contact": "زموږ ټیم سره اړیکه ونیسئ",

  // ========== CONTACT PAGE ==========
  "contactPage.tag": "اړیکه ونیسئ",
  "contactPage.title": "اړیکه او ملاتړ",
  "contactPage.subtitle": "پوښتنه لرئ، زموږ سره ملګرتیا غواړئ، یا ملاتړ ته اړتیا لرئ؟ موږ دلته یو چې مرسته وکړو — په انګلیسي، پښتو او دري.",
  "contactPage.form.title": "موږ ته پیغام واستوئ",
  "contactPage.form.submitted": "پیغام واستول شو!",
  "contactPage.form.submittedDesc": "د اړیکې لپاره مننه. زموږ ټیم به په ۲-۳ کاري ورځو کې ځواب ووایي.",
  "contactPage.form.another": "بل پیغام واستوئ",
  "contactPage.form.name": "بشپړ نوم *",
  "contactPage.form.namePlaceholder": "ستاسو بشپړ نوم",
  "contactPage.form.email": "بریښنالیک پته *",
  "contactPage.form.emailPlaceholder": "ستاسو بریښنالیک",
  "contactPage.form.phone": "د تلیفون شمېره",
  "contactPage.form.phonePlaceholder": "+1 (613) 555-0000",
  "contactPage.form.subject": "موضوع *",
  "contactPage.form.subjectPlaceholder": "یوه موضوع وټاکئ",
  "contactPage.form.subjectOptions.general": "عمومي پوښتنه",
  "contactPage.form.subjectOptions.donation": "د مرستې پوښتنه",
  "contactPage.form.subjectOptions.volunteer": "د رضاکارۍ غوښتنه",
  "contactPage.form.subjectOptions.partnership": "د ملګرتیا وړاندیز",
  "contactPage.form.subjectOptions.media": "رسنۍ او مطبوعات",
  "contactPage.form.subjectOptions.tech": "تخنیکي ملاتړ",
  "contactPage.form.subjectOptions.other": "نور",
  "contactPage.form.message": "پیغام *",
  "contactPage.form.messagePlaceholder": "څنګه کولی شو ستاسو مرسته وکړو؟",
  "contactPage.form.submit": "پیغام واستوئ",
  "contactPage.form.sending": "لیږل کیږي...",
  "contactPage.form.error": "یو څه غلط شول. مهرباني وکړئ بیا هڅه وکړئ یا موږ ته مستقیم بریښنالیک واستوئ.",
  "contactPage.form.charLimit": "پیغام باید ۵۰۰ حروف یا لږ وي.",
  "contactPage.form.privacy": "موږ ستاسو محرمیت ته درناوی لرو. ستاسو معلومات به هیڅکله له دریم اړخ سره شریک نه شي.",
  "contactPage.office.title": "زموږ دفتر",
  "contactPage.office.address": "پته",
  "contactPage.office.addressValue": "۱۲۳ رایډو سړک، سویټ ۴۰۰\nاوټاوا، اونټاریو K1N 5Y1، کاناډا",
  "contactPage.office.hours": "د دفتر ساعتونه",
  "contactPage.office.hoursValue": "دوشنبه – جمعه: ۹:۰۰ سهار – ۵:۰۰ ماښام EST",
  "contactPage.office.phone": "تلیفون",
  "contactPage.office.email": "بریښنالیک",
  "contactPage.map.directions": "لارښوونه ترلاسه کړئ",
  "contactPage.lang.title": "څو ژبیز ملاتړ",
  "contactPage.lang.desc": "موږ په انګلیسي، پښتو او دري کې ملاتړ چمتو کوو. مهرباني وکړئ په خپل پیغام کې خپله غوره ژبه په ګوته کړئ.",

  // ========== STORIES PAGE ==========
  "storiesPage.tag": "زموږ کیسې",
  "storiesPage.title": "د اغیزې او هیلې کیسې",
  "storiesPage.subtitle": "له ساحې څخه لومړني روایتونه ولولئ، زموږ د ماموریت تر شا خلکو سره ووینئ، او د CAF د وروستیو خبرونو څخه خبر اوسئ.",
  "storiesPage.filters.all": "ټول",
  "storiesPage.filters.fieldStories": "ساحوي کیسې",
  "storiesPage.filters.impactReports": "د اغیزې راپورونه",
  "storiesPage.filters.volunteerVoices": "د رضاکارانو غږونه",
  "storiesPage.filters.news": "خبرونه او تازه معلومات",
  "storiesPage.empty": "د دې کټګورۍ لپاره هیڅ کیسه ونه موندل شوه.",
  "storiesPage.readMore": "نور ولولئ",
  "storiesPage.backToStories": "ټولو کیسو ته وګرځئ",
  "storiesPage.by": "لیکوال",
  "storiesPage.published": "خپره شوې",

  // Stories Preview (Home)
  "storiesPreview.tag": "له ساحې څخه",
  "storiesPreview.title": "د اغیزې او هیلې کیسې",
  "storiesPreview.subtitle": "زموږ د خدمت شویو ټولنو ریښتیني کیسې — د هغو خلکو لخوا چې هره ورځ بدلون ژوند کوي.",
  "storiesPreview.viewAll": "ټولې کیسې ولولئ",

  // Photo Slider (Home)
  "photoSlider.tag": "په ساحه کې",
  "photoSlider.title": "زموږ کار په انځورونو کې",
  "photoSlider.subtitle": "د خپل ملاتړ اغیزه وګورئ — د افغانستان او کاناډا په اوږدو کې زموږ د پروژو ریښتیني شېبې.",
};

export default translations;